import {useEffect, useRef} from "react";
import {Typography} from '@bonprix/design-system';
import Landmark from '@core/scripts/components/landmark-adapter';

const NavigationItemsSlider =  ({ items, activeIndex, setActiveIndex, setNextActiveIndex, ref }) => {
      const itemRefs = useRef(items.map(() => useRef(null)));
      const activeLinesRefs = useRef(items.map(() => useRef(null)));
     const enableScroll = useRef(true);

     useEffect(() => {
         if (enableScroll.current) {
             const element = itemRefs.current[activeIndex].current;
             initialScroll(element);
         }
         enableScroll.current = true;
     }, [activeIndex]);

     const initialScroll = (element) => {
         const parent = element.parentNode;
         const parentRect = parent.getBoundingClientRect();
         const elementRect = element.getBoundingClientRect();

         const wishedX = parentRect.left + parentRect.width / 2 - elementRect.width / 2;
         const scrollX = elementRect.left - wishedX;

         if (parentRect.left !== 0 ||
             (elementRect.right > parentRect.width || elementRect.left < parentRect.left || elementRect.left < 0)) {
             parent.scrollBy(scrollX, 0);
         }
     };

     const handleClick = (event, index) => {
         event.preventDefault();

         const isActiveItem = index === activeIndex;
         const item = items[index];
         const naviLmValue = `hn\\${item.id}${isActiveItem ? '\\allSelect\\' : '\\\\'}`;
         Landmark.sendUserInterfaceLandmark({navi: naviLmValue});

         if (isActiveItem) {
             window.location.href = item.url;
         } else {
             setNextActiveIndex(index);
             const activeBar = activeLinesRefs.current[activeIndex].current;
             const translateX = calculateTranslateX(activeBar, index);

             const nextElement = itemRefs.current[index].current;
             const nextElementWidth = nextElement.getBoundingClientRect().width;

             activeBar.style.transition = 'width 0.35s ease, transform 0.3s ease';
             activeBar.style.transform = `translateX(${translateX}px)`;
             activeBar.style.width = `${nextElementWidth}px`;

             enableScroll.current = false;
             initialScroll(nextElement);

             setTimeout(() => {
                 setActiveIndex(index)
                 setNextActiveIndex(null);
             }, 300);
         }
     }

     const calculateTranslateX = (activeBar, newIndex) => {
         const nextElement = itemRefs.current[newIndex].current;
         const nextElementX = nextElement.getBoundingClientRect().x;
         const activeBarX = activeBar.getBoundingClientRect().x;
         return nextElementX - activeBarX;
     }

     return (
         <div className="navigation__items-slider" ref={ref}>
             {items.map((item, index) => {
                 const titleColor = item.fontColor || "primary";
                 return (
                 <a key={index} ref={itemRefs.current[index]} href={item.url} className="navigation__items-slider-item"
                    onClick={(event) => handleClick(event, index)}>
                     <Typography color={titleColor} variant="bonprix-h6">{item.title}</Typography>
                     {activeIndex === index &&
                         <div ref={activeLinesRefs.current[index]} className="navigation__slider-active-line"></div>}
                 </a>
                 )
                })
             }
         </div>
     );

 };

export default NavigationItemsSlider;